import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import ProcessingSpinner from '../ProcessingSpinner';
import UpgradePlanButton from '../UpgradePlanButton';

import { hasFeature } from '../../helpers/Features';

const ExternalAuthAccountListItem = ({
  integration,
  account,
  connectingUuid,
  handleConnect,
}) => {
  const intl = useIntl();

  return (
    <li className="external-auth-account">
      <div className="external-auth-account-icon">
        <span style={{ backgroundColor: account.color }}>
          {account.name.charAt(0).toUpperCase()}
        </span>
      </div>
      <div className="external-auth-account-details">
        <h4 className="external-auth-account-domain">
          {account.domain}
        </h4>
        <span className="external-auth-account-name">
          {account.user_name} ({account.role_name})
        </span>
      </div>
      <div className="external-auth-account-actions">
        {hasFeature(account.features, integration.feature?.slug) ? (
          <Button
            title={intl.formatMessage({
              defaultMessage: 'Connect to {integrationName}',
            }, { integrationName: integration.name })}
            disabled={!!connectingUuid}
            onClick={() => {
              handleConnect(account.uuid);
            }}
          >
            {(!!connectingUuid && connectingUuid === account.uuid) ? (
              <ProcessingSpinner />
            ) : (
              <i className="fa-regular fa-link" />
            )}
          </Button>
        ) : (
          <UpgradePlanButton
            feature={integration.feature.slug}
            featureObject={integration.feature}
            forceButton={true}
          />
        )}
      </div>
    </li>
  );
};

ExternalAuthAccountListItem.propTypes = {
  integration: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  connectingUuid: PropTypes.string,
  handleConnect: PropTypes.func.isRequired,
};

ExternalAuthAccountListItem.defaultProps = {
  connectingUuid: null,
};

export default ExternalAuthAccountListItem;
